module.exports = __webpack_public_path__ + "components/flag/static/square/cx-b59f4165df16f46f8b45c67ce94a1bf7.svg";